<template>
  <span class="az_issue"
    @mouseout="mouseoutHandler"
    @mouseover="mouseoverHandler">
    <i v-if="level === 'error'"
      class="el-icon-info"
      :class="issueIcon"
      @click="activeHandler">
    </i>
    <i v-if="level === 'issue'"
      class="el-icon-info"
      :class="issueIcon"
      @click="activeHandler">
    </i>
    <span class="issue-txt">
      <slot></slot>
    </span>
    <transition name="el-fade-in-linear">
      <s v-show="showTxt"
        class="issue-tip-txt"
        :class="[level, txtToward]"
        :style="{minWidth: tipW+'px'}">
        <em></em>
        <template v-if="curText.length > 1">
          <span v-for="(item, index) in curText"
            :key="index"><del>{{index + 1}}.</del>{{item}}</span>
        </template>
        <span v-else>{{curText[0]}}</span>
      </s>
    </transition>
  </span>
</template>

<script>
export default {
  name: 'az-issue',
  data() {
    return {
      issueIcon: [], // , 'az-tuoyuan'
      showTxt: false
    };
  },
  props: {
    type: {
      type: String,
      default: 'link' // link, hover
    },
    level: {
      type: String,
      default: 'issue' // issue 疑问，error错误
    },
    to: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    tipW: {
      type: Number,
      default: 180
    },
    txtToward: {
      type: String,
      default: 'right' // 默认提示的位置，right, left,bottom, top
    }
  },

  computed: {
    curText() {
      if (!this.text) return [];
      return (this.text + '').split('\\r') || [];
    },
    normalIcon() {
      if (this.level == 'error') return 'az-app-tanhao';
      if (this.level == 'issue') return 'az-app-wenhao';
      return 'az-tanhao';
    },
    hoverIcon() {
      if (this.level == 'error') return 'az-app-tanhao_01';
      if (this.level == 'issue') return 'az-app-tuoyuan';
      return 'az-tanhao_01';
    }
  },
  created() {
    this.issueIcon = [this.normalIcon];
  },
  methods: {
    mouseoverHandler() {
      this.issueIcon = [this.hoverIcon];
      if (this.text) {
        this.showTxt = true;
      }
    },

    mouseoutHandler() {
      this.issueIcon = [this.normalIcon];
      this.showTxt = false;
    },

    activeHandler() {
      if (this.to) {
        window.open(this.to);
      }

    }
  }
};
</script>

<style lang="scss" scoped>
span.az_issue {
  position: relative;
  text-align: left;

  i.issue-icon {
    font-size: 14px;
    cursor: pointer;
    position: relative;

    &:active {
      opacity: 0.5;

      s {
        opacity: 1;
      }
    }
  }

  span.issue-txt {
    color: #9aa3ac;
  }

  s.issue-tip-txt {
    z-index: 2;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    line-height: 18px;
    min-height: 18px;
    padding: 6px 0 6px 8px;
    color: #666;
    border-radius: 2px;
    max-width: 180px;
    min-width: 180px;
    background-color: #f9fcff;
    box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.04);
    border: solid 1px #e6ecef;

    > span {
      word-break: break-all;
      font-size: 12px;
      display: block;
      position: relative;
      padding-left: 11px;

      > del {
        position: absolute;
        left: 0;
      }
    }

    > em {
      position: absolute;
      top: 50%;
      margin-top: -5px;
      width: 10px;
      height: 10px;
      background-color: #f9fcff;
      border-left: solid 1px #ececec;
      border-bottom: solid 1px #ececec;
    }

    &.error {
      background-color: #fff;
      color: #ea5b6d;
      border: solid 1px #ea5b6d;

      > em {
        border-left: solid 1px #ea5b6d;
        border-bottom: solid 1px #ea5b6d;
      }
    }

    &.right {
      left: 26px;

      > em {
        left: -6px;
        transform: rotate(45deg);
      }
    }

    &.left {
      right: 26px;

      > em {
        right: -6px;
        transform: rotate(-135deg);
      }
    }
  }

  &.small {
    i.issue-icon {
      font-size: 12px;
    }

    s.issue-tip-txt {
      padding: 4px 4px 4px 4px;

      > span {
        padding-left: 4px;
      }
    }
  }
}

.az-app-wenhao {
  color: #b0b0b0;
}

.az-app-tuoyuan {
  color: #589ff0;
}

.az-app-tanhao_01 {
  color: #ea5b6d;
}

.az-app-tanhao {
  color: #ea5b6d;
}
</style>